<template>
    <div>
        <el-container class="toolBar">
            <el-main style="overflow-y: hidden;padding-bottom: 10px">
                <div >
                    <el-form :inline="true" style="text-align: left;padding-left:10px;" label-width="100px">
                        <div>
                            <el-form-item label="年月">
                                <el-date-picker
                                        v-model="yearMonth"
                                        size="medium"
                                        type="month"
                                        value-format="yyyy-MM"
                                        format="yyyy-MM"  placeholder="选择年月">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="部门">
                                <selectTree style="width: 180px" v-model="tree_model" :rowKeys="treekeys" :tree-data="treeData" :isMulti="false"
                                            placeholder="请选择顶级部门"></selectTree>
                            </el-form-item>
                            <el-form-item>
                                <el-button icon="el-icon-search" type="primary" size="medium" @click="search">
                                    查询
                                </el-button>
                                <el-button icon="el-icon-download" type="primary" size="medium" @click="excel">
                                    导出
                                </el-button>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="Xdriver"></div>
            </el-main>
        </el-container>
    </div>
</template>

<script>

    import selectTree from '@/components/tools/tree/selectTree'

    export default {
        name: 'toolBar',
        props: ['toolHeight', 'loading'],
        components: {
            selectTree
        },
        data() {
            return {
                tree_model: {
                },
                treeData: [],
                treekeys: {
                    id: 'id',
                    name: 'name',
                    parent: 'parentId',
                    children: 'children'
                },
                searBarHeight: 70,
                yearMonth:"",
                departmentName:""
            }
        },
        mounted(){
            this.getDepartmentTree();
        },
        methods: {
            async getDepartmentTree() {
                this.dialoading = true;
                let param = {
                    url:"/department/listTopZTree",
                    param:{}
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == "0") {
                    const retData = data.data.jsonStr;
                    if(retData){
                        this.treeData = retData;
                    }
                }
                this.dialoading = false;
            },
            closeDialog() {
            },
            search() {

                this.departmentName = this.tree_model.name;
                let searchData = {
                    yearMonth:this.yearMonth,
                    departmentName:this.departmentName,
                    reCreate:"1"
                }
                this.$emit('search',searchData);
            },
            excel() {
                this.departmentName = this.tree_model.name;
                let searchData = {
                    departmentName:this.departmentName,
                    yearMonth:this.yearMonth,
                    reCreate:"1"
                }
                this.$emit('excel',searchData);
            },
        }
    }
</script>

